<template>
  <div class="contact">
    <div class="grey-card">
      <div class="contact card">
        <div class="title">{{ $t('Contact.title1') }}</div>
        <div class="line"></div>
        <div class="content">
          <el-timeline class="contact-info">
            <el-timeline-item v-for="(contact, index) in contacts" :key="index" :type="contact.type">
              <el-card>
                <div class="flex">
                    <div style="width:60%">
                      <!-- <h4><i :class="contact.icon"></i>{{ ' ' + contact.item }}</h4> -->
                      <h5 v-html="contact.content"></h5>
<!--                      <h5 v-html="contact.content11"></h5>-->
                    </div>

<!--                    <div style="width:40%;  text-align: left;">-->
<!--                      <h5>{{contact.active}}</h5>-->
<!--                      <img :src="contact.img" alt="" height="200px">-->
<!--                    </div>-->
                </div>

              </el-card>
            </el-timeline-item>
          </el-timeline>

        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">


.contact {
  .content {
    .contact-info {
      width: 70%;
      margin: 0 auto;
    
      .el-card {
        h4 {
          font-size: 20px;
          line-height: 20px;
          color: #535051;
        }
        h5 {
          margin-top: 20px;
          font-size: 28px;
          line-height: 28px;
        }
      }
      .flex{
        display: flex;
      }
      
    }
  }
}
</style>

<script>
export default {
  name: 'Contact',
  computed: {
    contacts() {
      return this.$t('Contact.contacts');
    },
  },
  data() {
    return {};
  },
};
</script>
